import React, { useState, useRef, useEffect } from 'react';
import './index.scss';

const DisplayContainer = (props) => {
    const {
        images = [],
        alt = 'display content',
        className = ''
    } = props;

    const contentRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);

    const resolveSrc = (item) => {
        if (!item) return '';
        if (typeof item === 'string') return item;
        const target = item.url || item;
        return target.default || target;
    };

    const columnsCount = 3;
    const columns = Array.from({ length: columnsCount }, () => []);
    images.forEach((img, index) => {
        columns[index % columnsCount].push(img);
    });

    const checkScrollable = () => {
        if (contentRef.current) {
            const { scrollHeight, clientHeight } = contentRef.current;
            setIsScrollable(scrollHeight > clientHeight);
        }
    };

    useEffect(() => {
        checkScrollable();
        window.addEventListener('resize', checkScrollable);
        return () => window.removeEventListener('resize', checkScrollable);
    }, [images]);

    return (
        <div className={`display_container ${isScrollable ? 'has-fade' : ''} ${className}`}>
            <div className='display_content' ref={contentRef}>
                <div className='display_masonry_grid'>
                    {columns.map((colImages, colIndex) => (
                        <div key={colIndex} className='display_column'>
                            {colImages.map((img, imgIndex) => (
                                <img
                                    key={imgIndex}
                                    src={resolveSrc(img)}
                                    className='display_img'
                                    alt={alt}
                                    onLoad={checkScrollable}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DisplayContainer;